<template>
    <grid
        ref="grid"
        :isAutoWidth="true"
        :isSearch="false"
        :columnDefs="columnDefs"
        :rowData="logs"
    ></grid>
</template>

<script>
import API from '../../../api';
import Grid from '../../generic/grid/grid.vue';
import { TEAM_MEMBER_BY_ID_ENDPOINT } from '../../../endpoints';

export default {
    name: 'TeamMemberEditLog',
    components: {
        Grid,
    },
    props: {
        teamMember: Object,
    },
    computed: {
        columnDefs() {
            return [
                {
                    headerName: 'Date',
                    type: 'dateTimeColumn',
                    field: 'action_date',
                },
                {
                    headerName: 'Message',
                    field: 'message',
                },
                {
                    field: '',
                    headerName: '',
                    autoWidthExclude: true,
                    sortable: false,
                },
            ]
        }
    },
    data() {
        return {
            busy: false,
            logs: [],
        }
    },
    mounted() {
        (async () => {
            this.busy = true;
            try {
                await this.fetchLog();
            } finally {
                this.busy = false;
            }
        })();
    },
    methods: {
        async fetchLog() {
            try {
                const { data } = await API.get(TEAM_MEMBER_BY_ID_ENDPOINT(this.teamMember.id, 'log'));
                this.logs = data;
            } catch (err) {
                this.errorToast({text: 'Could not load log data.'})
            }
        }
    }
}
</script>
